import { useEffect } from 'react';

import type { BatchComicUploadStore } from '../../BatchComic/batchComicUploadStore';
import type { BatchMascotUploadStore } from '../../BatchMascot/batchMascotUploadStore';
import { takeAssetLibraryOpenWithPrefill } from '../assetLibraryOpenWithPrefill';

export function applyOpenWithComicPrefill(store: BatchComicUploadStore) {
  const prefill = takeAssetLibraryOpenWithPrefill();
  if (!prefill || prefill.target !== 'comic') {
    return;
  }

  store.addLibraryVideos([prefill.selection]);
}

export function applyOpenWithMascotPrefill(store: BatchMascotUploadStore) {
  const prefill = takeAssetLibraryOpenWithPrefill();
  if (!prefill || prefill.target !== 'mascot') {
    return;
  }

  const row = store.state.mascotRows[0];
  if (!row) {
    return;
  }

  switch (prefill.slot) {
    case 'motion':
      store.setRowLibraryMotionRef(row.id, prefill.selection);
      break;
    case 'character':
      store.setRowLibraryCharRefs(row.id, [prefill.selection]);
      break;
    case 'background':
      store.setRowLibraryBackgroundRef(row.id, prefill.selection);
      break;
  }
}

export function useOpenWithComicPrefill(store: BatchComicUploadStore) {
  useEffect(() => {
    applyOpenWithComicPrefill(store);
  }, [store]);
}

export function useOpenWithMascotPrefill(store: BatchMascotUploadStore) {
  useEffect(() => {
    applyOpenWithMascotPrefill(store);
  }, [store]);
}
